const initialState = {
    scaleContents: [],
    scaleAnswers: [],
    multipleChoiceContents: [],
    multipleChoiceAnswers: [],
    checkboxContents: [],
    rankingContents: [],
    rankingAnswers: [],
    header: '',
    freeText:'',
    hoverList: [],

    isTraitSurvey: false,
    calculateAverage: false,
    hasSubTraits: false,
    resultLogics: [],
    subTrait: [],

    subtraitsMaxScoreDictionary: {},
    subtraitsMaxScoreList: [],
    maxScore: 0,

    questionList: []
};

const surveyQuestionReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_HEADER':
            return { ...state, header: action.header };
        case 'SET_FREETEXT':
            return { ...state, freeText: action.freeText };
        case 'SET_SCALE_CONTENTS':
            return { ...state, scaleContents: action.scaleContents };
        case 'SET_SCALE_ANSWERS':
            {
                return { ...state, scaleAnswers: action.scaleAnswers };

            }
        case 'SET_MULTIPLECHOICE_CONTENTS':
            return { ...state, multipleChoiceContents: action.multipleChoiceContents };
        case 'SET_MULTIPLECHOICE_ANSWERS':
            return { ...state, multipleChoiceAnswers: action.multipleChoiceAnswers };
        case 'SET_CHECKBOX_CONTENTS':
            return { ...state, checkboxContents: action.checkboxContents };
        case 'SET_RANKING_CONTENTS':
            return { ...state, rankingContents: action.rankingContents };
        case 'SET_RANKING_ANSWERS':
            return { ...state, rankingAnswers: action.rankingAnswers };
        case 'SET_HOVER':
            return { ...state, hoverList: action.hoverList };

        case 'SET_CALCULATE_AVERAGE':
            return { ...state, calculateAverage: action.calculateAverage };
        case 'SET_HAS_SUBTRAITS':
            return { ...state, hasSubTraits: action.hasSubTraits };
        case 'SET_RESULT_LOGIC':
            return { ...state, resultLogics: action.resultLogics };
        case 'SET_SUBTRAIT':
            return { ...state, subTrait: action.subTrait };
        case 'SET_IS_TRAITSURVEY':
            return { ...state, isTraitSurvey: action.isTraitSurvey };

        case 'SET_SUBTRAITS_MAXSCORE_DICTIONARY':
            return { ...state, subtraitsMaxScoreDictionary: action.subtraitsMaxScoreDictionary };
        case 'SET_SUBTRAITS_MAXSCORE_LIST':
            return { ...state, subtraitsMaxScoreList: action.subtraitsMaxScoreList };
        case 'SET_MAXSCORE':
            return { ...state, maxScore: action.maxScore };
        case 'SET_QUESTION_LIST':
            {
                return { ...state, questionList: action.questionList };

            }
        default:
            return state;
    }
}

export { surveyQuestionReducer as default }